/**
 * Call status notification helpers.
 *
 * All billing is handled by ASTPP on FreeSWITCH.
 * This module only notifies the call-control edge function of status
 * changes so the UI can track call state.
 */

import { supabase } from '@/integrations/supabase/client';

export type CallEndAction = 'ended' | 'cancelled' | 'failed';

export interface NotifyCallEndParams {
  callId: string;
  sessionId: string;
  action: CallEndAction;
  durationSeconds: number;
  reason?: string;
}

export interface NotifyCallEndResult {
  success?: boolean;
  status?: string;
  duration?: number;
  chargedCents?: number;
  balanceAfterCents?: number | null;
  error?: string;
}

/**
 * Notify the `call-control` edge function that a call has ended.
 * Fire-and-forget-safe: errors are logged but never thrown.
 */
export async function notifyCallEnd(params: NotifyCallEndParams): Promise<NotifyCallEndResult | null> {
  try {
    const { data, error } = await supabase.functions.invoke('call-control', {
      body: {
        action: params.action,
        callId: params.callId,
        sessionId: params.sessionId,
        durationSeconds: params.durationSeconds,
        reason: params.reason,
      },
    });
    if (error) throw error;
    return (data || null) as NotifyCallEndResult | null;
  } catch (err) {
    console.error('[call-billing] Failed to notify call-control:', err);
    return null;
  }
}
